var exports = {
  "B": "tickle__wt_qUW",
};

module.exports = exports;
